// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EKn1w","importantInfo":"styles_importantInfo__3b3Sc"};